import { NavLink } from 'react-router-dom';

export interface PillTab {
  to: string;
  label: string;
  /** Optional — when omitted, NavLink's default end=false matching is used.
   * Set `end` on pills whose `to` is a prefix of another pill's `to`
   * (e.g. /podcasts vs /podcasts/shows — pass `end` on /podcasts). */
  end?: boolean;
}

export function PillTabs({ tabs }: { tabs: PillTab[] }) {
  return (
    <div className="sticky top-14 z-30 bg-background/70 backdrop-blur-md backdrop-saturate-150 border-b border-border">
      <div className="flex gap-2 overflow-x-auto px-3 py-3 no-scrollbar">
        {tabs.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              [
                'shrink-0 px-3 py-1.5 rounded-full text-sm font-medium transition-colors',
                isActive
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-card border border-border text-muted-foreground hover:text-foreground',
              ].join(' ')
            }
          >
            {t.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
